
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class PreProductionService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.user_data_url =
      appData.serviceURL +
      `/${process.env.REACT_APP_PREPRODUCTION_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getPreProductionPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getPreProductionPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPreProductionProcess(input, responseCallBack, errorCallBack) {
    this.method(
      "createPreProductionProcess",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initPreProductionProcessModule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "initPreProductionProcessModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApprovePreProduction(input, responseCallBack, errorCallBack) {
    this.method(
      "createAndApprovePreProduction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePreProduction(input, responseCallBack, errorCallBack) {
    this.method("updatePreProduction", input, responseCallBack, errorCallBack);
  }
  static unLockPreProductionNumber(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockPreProductionNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApprovePreProduction(input, responseCallBack, errorCallBack) {
    this.method(
      "updateAndApprovePreProduction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unApprovePreProduction(input, responseCallBack, errorCallBack) {
    this.method(
      "unApprovePreProduction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelPreProduction(input, responseCallBack, errorCallBack) {
    this.method("cancelPreProduction", input, responseCallBack, errorCallBack);
  }
  static finishPreProduction(input, responseCallBack, errorCallBack) {
    this.method("finishPreProduction", input, responseCallBack, errorCallBack);
  }
  static PreProduction_Image_Upload(input, responseCallBack, errorCallBack) {
    this.method(
      "PreProduction_Image_Upload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.user_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.user_data_url,responseCallBack, errorCallBack);

    }
  }
}
